<div class="container delete-job">
    <p class="msg">Are you sure you want to delete <b>{{jobTitle}}</b> job</p>
    <p class="buttons">
        <button (click)="deleteJob('Yes')" class="btn btn-primary btn-md">Yes</button>
        <button (click)="deleteJob('No')" class="btn btn-primary btn-md">No</button>
    </p>
</div>